import { render, staticRenderFns } from "./organism.modal.ugcUploadingImage.vue?vue&type=template&id=0b11416c"
import script from "./organism.modal.ugcUploadingImage.vue?vue&type=script&lang=ts"
export * from "./organism.modal.ugcUploadingImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports